export const getUserMeetingNames = (members, role, userId) => {
  if (!Array.isArray(members)) return [];
  return members.map((member) => {
    member.userData.meetingName = getUserMeetingName(
      member.userData,
      role,
      userId,
      member.id
    );
    return member;
  });
};

export const getUserMeetingName = (userData, role, userId, memberId) => {
  let { meetingName, name } = userData;

  if (!meetingName || meetingName === 'null') {
    return name;
  } else {
    if ((role === 'admin' || role === 'moderator') && userId !== memberId) {
      return `${meetingName} (${name})`;
    }
    return meetingName;
  }
};
